import React from 'react'

const UpdateFieldsModalSkeleton = () => {
  return (
    <div className="flex animate-pulse flex-col justify-between gap-7">
      <div className="bg-skeleton-primary rounded-sm py-2.5 text-transparent">.</div>
      <div className="bg-skeleton-primary rounded-sm py-2.5 text-transparent">.</div>
      <div className="bg-skeleton-primary rounded-sm py-2.5 text-transparent">.</div>
      <div className="bg-skeleton-primary rounded-sm py-2.5 text-transparent">.</div>
      <div className="bg-skeleton-primary rounded-sm py-2.5 text-transparent">.</div>
      <div className="bg-skeleton-primary rounded-sm py-2.5 text-transparent">.</div>
      <div className="bg-skeleton-primary rounded-sm py-2.5 text-transparent">.</div>
    </div>
  )
}

export default UpdateFieldsModalSkeleton
